import { CalendarHolidaysRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: CalendarHolidaysRepository): Interactor {
  return (planzone) =>
    present(
      repository
        .getCalendarsHolidays()
        .then((calendarsHolidays) => ({ planzone, calendarsHolidays }))
        .catch((e) => Promise.reject({ ...e, planzone })),
    );
}

export type { Interactor };

export { createInteractor };
